
import { RegexConstants } from "../../constants/RegexConstants";
/**
 * @method validateStringOnly - Only allows alphanumeric, accented and some special(-'":,) characters
 * @param {*} value
 */
export const validateStringOnly = value => {
  return value && value !== '' ? RegexConstants.STRING_ONLY.test(value) : true;
}

/**
 * Removed logic for url validation, it fails on many url with special characters
 */
export const validateLinkedInUrl = url => {
  return true;
}

/**
 * Removed logic for url validation, it fails on many url with special characters
 */
export const validateGithubUrl = url => {
  return true
}